import { render, staticRenderFns } from "./PosSettings.vue?vue&type=template&id=0d253065&scoped=true"
import script from "./PosSettings.vue?vue&type=script&lang=js"
export * from "./PosSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d253065",
  null
  
)

export default component.exports